import React, { useContext } from "react";
import { Form, Col, Row } from "react-bootstrap";

import { RequiredMark, RequiredMarkContext } from "components";

import styles from "./fields.module.scss";
import clsx from "clsx";

export const CustomInput = ({
	input,
	as,
	label,
	helperLabel,
	type,
	placeholder,
	meta: { touched, error, warning },
	disabled,
	disableInput,
	commonName,
	smLabel = 6,
	smSelect = 6,
	tabIndex,
	normalizeOnBlur,
	maxHeight = false,
	role = false,
	customError,
	wrapperClassName,
	hideRequiredMark, //works only with RequiredMarkContext
}) => {
	const showRequiredMark =
		useContext(RequiredMarkContext) && !hideRequiredMark && !disabled;

	const checkSpanRequired = showRequiredMark && <RequiredMark />;

	const disabledClass = disabled ? styles.disabled : "";
	const labelBlock = label && (
		<Col sm={smLabel}>
			<Form.Label className={styles.wrappLabel}>
				<span>
					{label}
					{checkSpanRequired}
				</span>
			</Form.Label>
			{helperLabel && (
				<span className={styles.helperLabel}>{helperLabel}</span>
			)}
		</Col>
	);

	const showError = !disabled && !disableInput;
	const errorMessage = error && <p className={styles.spanError}>{error}</p>;
	const customErrorMessage = customError && (
		<p className={styles.spanError}>{customError}</p>
	);
	const warningMessage = warning && (
		<p className={styles.spanWarn}>{warning}</p>
	);

	const hasError =
		(showError && touched && (errorMessage || customErrorMessage)) ||
		warningMessage;

	const validationClass =
		showError &&
		touched &&
		(((error || customError) && styles.error) ||
			(warning && styles.warning));

	const onBlurHandler = event => {
		if (normalizeOnBlur) {
			event.target.value = normalizeOnBlur(event.target.value);
		}

		//Origin onblur
		input.onBlur(event);
	};

	let checkRole = role ? styles.merhantDesc : null;
	let checkHeight = maxHeight ? styles.maxHeight : null;

	const inputField = (
		<>
			<Form.Control
				{...input}
				as={as}
				onBlur={onBlurHandler}
				tabIndex={tabIndex}
				common-name={commonName}
				placeholder={placeholder}
				disabled={disabled || disableInput}
				type={type}
				isInvalid={touched && errorMessage}
				className={clsx(
					styles.field,
					checkRole,
					validationClass,
					checkHeight,
				)}
			/>
			{hasError}
		</>
	);

	return (
		<span className={clsx(disabledClass, styles.formGroup)}>
			<Form.Group
				as={Row}
				className={clsx(styles.inputWrapper, wrapperClassName)}
			>
				{labelBlock}
				<Col sm={smSelect}>{inputField}</Col>
			</Form.Group>
		</span>
	);
};
